module.exports = __webpack_public_path__ + "img/Mountains.4d484f02.png";